<template>
  <div :class="{ pin: true, 'is-active': isActive }">
    <div class="overlay" @click="toggle"></div>
    <div class="tooltip-container">
      <div class="tc-arrow float-right"></div>
      <div class="tc-content float-right">
        <div class="tc-content-inner">
          <h2 class="mb-0">
            {{
              caseItem.road && caseItem.road.name
                ? caseItem.road.name
                : "Address Unavailable"
            }}
          </h2>
          <h3 v-if="caseItem.road" class="mb-1 text-uppercase">
            {{ caseItem.road.subdistrict }}, {{ caseItem.road.district }}
          </h3>
          <h3>
            {{ formatCoord(caseItem.lat) }}, {{ formatCoord(caseItem.lng) }}
          </h3>
          <div
            v-if="
              type === 'image' &&
              caseItem &&
              caseItem.media &&
              caseItem.media[0]
            "
            class="tc-img"
            :style="style"
          ></div>
          <div
            v-if="
              type === 'video' &&
              caseItem &&
              caseItem.media &&
              caseItem.media[0]
            "
            class="tc-vid"
          >
            <video autoplay width="320" height="180" controls>
              <source :src="caseItem.media[0].url" type="video/mp4" />
            </video>
          </div>
          <h4 v-if="caseItem.source == 'socialMedia'">
            Submited by {{ caseItem.socmedUsername }}
            <font-awesome-icon
              :icon="getCaseIcon(caseItem.type).i"
              class="media-icon float-right"
              :class="`text-${getCaseIcon(caseItem.type).color}`"
            />
          </h4>
          <h4 v-else-if="caseItem.source != 'socialMedia' && caseItem.user">
            Submited by {{ caseItem.user.name }}
            <font-awesome-icon
              :icon="getCaseIcon(caseItem.type).i"
              class="media-icon float-right"
              :class="`text-${getCaseIcon(caseItem.type).color}`"
            />
          </h4>
          <h4 v-else>User data unavailable</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helper from "@/helper";

export default {
  props: ["caseItem", "selectedCaseItem", "map"],
  methods: {
    formatCoord(coord) {
      if (!coord) {
        return "";
      } else {
        return parseFloat(coord).toFixed(6);
      }
    },
    toggle() {
      if (this.isActive) this.$emit("selected", null);
      else this.$emit("selected", this.caseItem);
    },
    getCaseIcon(type) {
      return Helper.socialMediaIcons(type);
    },
  },
  computed: {
    isActive() {
      return (
        this.selectedCaseItem && this.selectedCaseItem._id == this.caseItem._id
      );
    },
    style() {
      return {
        "background-image":
          this.caseItem.media && this.caseItem.media[0]
            ? `url(${this.caseItem.media[0].url})`
            : "",
        "background-size": "auto 100%",
        "background-repeat": "no-repeat",			
		"background-position": "center",
		"background-color": "#000"
      };
    },
    type() {
      if (this.caseItem.media && this.caseItem.media[0]) {
        return this.caseItem.media[0].mime.includes("video")
          ? "video"
          : "image";
      }
    },
  },
  async mounted() {
    new mapboxgl.Marker(this.$el)
      .setLngLat([this.caseItem.lng, this.caseItem.lat])
      .addTo(this.map);
  },
};
</script>
